"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("../styles");
/**
 * Renders a list of errors and an instructional header message
 */
const Errors = ({ errors, headerText, refToFormTop }) => {
    return errors.length ? (react_1.default.createElement("div", { ref: refToFormTop, tabIndex: -1 },
        react_1.default.createElement(styles_1.ErrorListMessage, null,
            react_1.default.createElement("strong", null, headerText)),
        react_1.default.createElement(styles_1.ErrorList, null, errors.map((error) => {
            if (error) {
                return (react_1.default.createElement("li", { key: error },
                    react_1.default.createElement(styles_1.ErrorListItemMessage, null, error)));
            }
            return null;
        })))) : null;
};
Errors.propTypes = {
    errors: prop_types_1.default.arrayOf(prop_types_1.default.string),
    headerText: prop_types_1.default.string,
    refToFormTop: prop_types_1.default.objectOf(Object).isRequired
};
Errors.defaultProps = {
    errors: [],
    headerText: ''
};
exports.default = Errors;
//# sourceMappingURL=error-list.js.map